module.exports = __webpack_public_path__ + "img/desktopRight.1e19591b.png";